import { api } from "./api/client";
import { INDICADORES_FALLBACK, type Indicadores } from "@/lib/monto";

const MINDICADOR_URL = "https://mindicador.cl/api";
const TIMEOUT_MS = 5_000;

function valido(v: unknown): v is Indicadores {
  const i = v as Indicadores | undefined;
  return Boolean(i && Number.isFinite(i.uf) && Number.isFinite(i.utm) && i.uf > 0 && i.utm > 0);
}

/** Consulta pública a mindicador.cl (API abierta, sin API key). */
async function fetchPublico(): Promise<Indicadores | null> {
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), TIMEOUT_MS);
    const res = await fetch(MINDICADOR_URL, { signal: ctrl.signal });
    clearTimeout(timer);
    if (!res.ok) return null;
    const json = (await res.json()) as {
      uf?: { valor?: number; fecha?: string };
      utm?: { valor?: number; fecha?: string };
    };
    const candidato: Indicadores = {
      uf: Number(json.uf?.valor),
      utm: Number(json.utm?.valor),
      fecha: (json.uf?.fecha ?? new Date().toISOString()).slice(0, 10),
      fuente: "mindicador",
    };
    return valido(candidato) ? candidato : null;
  } catch {
    return null;
  }
}

export const indicadoresService = {
  /**
   * UF y UTM del día. Orden: backend (caché + persistencia) → API pública
   * mindicador.cl en tiempo real → valores de respaldo locales.
   */
  get: async (): Promise<Indicadores> => {
    try {
      const { data } = await api.get<Indicadores>("/indicadores");
      if (valido(data)) return data;
    } catch {
      // Sin sesión o backend caído: seguimos con la API pública.
    }
    return (await fetchPublico()) ?? INDICADORES_FALLBACK;
  },
};
